import { ClaimDocument } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export type GapClaimDocument = {
    claimId: number;
    documentTypeId: number;
    documentStatusId: number;
    documentTitle: string;
    documentDescription: string;
};

export class ClaimApi {
    getClaimDocuments(
        claimId: number,
        token: string,
        successCallback: (value: GapClaimDocument[]) => void = null,
        failureCallback = null
    ) {
        const getUrl = `/api/Claim/getClaimDocuments/${claimId}`;
        new ApiHelper().getDataSecure(
            getUrl,
            token,
            successCallback,
            failureCallback
        );
    }

    saveClaimDocuments(
        claimDocument: ClaimDocument,
        token: string,
        successCallback = null,
        failureCallback = null
    ) {
        const postUrl = '/api/Claim/saveClaimDocuments';
        new ApiHelper().postDataWithResponseSecure(
            postUrl,
            claimDocument,
            token,
            successCallback,
            failureCallback
        );
    }

    saveGapClaim(files, token, successCallback = null, failureCallback = null) {
        const postUrl = '/api/Claim/saveGapClaim';
        new ApiHelper().postDataWithResponseSecure(
            postUrl,
            files,
            token,
            successCallback,
            failureCallback
        );
    }

    saveClaimComments(
        comments,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        const postUrl = '/api/Claim/SaveGapClaimComments';
        new ApiHelper().postDataWithResponseSecure(
            postUrl,
            comments,
            token,
            successCallback,
            failureCallback
        );
    }
}
